module.exports = __webpack_public_path__ + "static/img/zgkxy.232bc53.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/zgkxy.jpg
// module id = T2uN
// module chunks = 73